/**
 * The collapsed flag lives in a cookie, not localStorage, so a server-rendered
 * host can read it and paint the first byte already collapsed — no expanded ->
 * collapsed 56px jump after hydration.
 *
 * Per-origin by design: app.arthelper.ai and www.arthelper.com are different
 * registrable domains and share no cookie scope. There is no cross-origin sync.
 */
const COLLAPSED_COOKIE = 'arthelper_suite_nav_collapsed';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
function readCollapsed() {
    if (typeof document === 'undefined') {
        return null;
    }
    const match = document.cookie.split('; ').find((entry) => entry.startsWith(`${COLLAPSED_COOKIE}=`));
    if (!match) {
        return null;
    }
    return match.slice(COLLAPSED_COOKIE.length + 1) === 'true';
}
function writeCollapsed(collapsed) {
    if (typeof document === 'undefined') {
        return;
    }
    document.cookie = `${COLLAPSED_COOKIE}=${collapsed}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax`;
}
export { COLLAPSED_COOKIE, readCollapsed, writeCollapsed };
//# sourceMappingURL=cookie.js.map